import React, { Component, createRef } from "react";
import DataTable from './TableBase';
import { contactColumns } from './RecordCells';
import { withRouter } from "react-router-dom";
import Swal from "sweetalert2";
import { apiCall } from "../../helpers/MainHelper";
import withPermissions from "../WithPermissions";
import ReactDOMServer from "react-dom/server";
import ReactLoading from "react-loading";
class CustomersTable extends Component {

    constructor(props) {
        super(props);
        this.tableRef = createRef();
        this.state = {
            pending: true
        }

    }
    handleDelete = async (customerId) => {
        const result = await Swal.fire({
            title: 'Silmek istediğinize emin misiniz?',
            text: "Bu işlem geri alınamaz.Müşteriye ait tüm veriler silinir!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Evet, sil!',
            cancelButtonText: 'Hayır, iptal et',
            preConfirm: async () => {
                const confirmButton = Swal.getConfirmButton();
                const originalButtonText = confirmButton.innerHTML;
                confirmButton.disabled = true;
                confirmButton.innerHTML = ReactDOMServer.renderToString(<ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />);

                try {
                    await apiCall('business/customer/delete/' + customerId, 'delete');
                    await this.triggerFetch();
                    return true;
                } catch (error) {
                    return false;
                } finally {
                    confirmButton.innerHTML = originalButtonText;
                    confirmButton.disabled = false;
                }
            }
        });

        if (result.isConfirmed) {
            if (result.value) {
                Swal.fire(
                    'Silindi!',
                    'Müşteri başarıyla silindi.',
                    'success'
                );
            } else {
                Swal.fire(
                    'Hata!',
                    'Silme işlemi başarısız oldu.',
                    'error'
                );
            }
        }
    }
    triggerFetch = (page = 1, size = 10, search = '') => {
        if (this.tableRef.current) {
            this.tableRef.current.fetchData(page, size, search);
        }
    };
    handleCustomerDetail = (customerId) => {
        this.props.history.push(`/customer-detail/${customerId}`);
    }
    render() {
        const { pending } = this.state;
        const { userPermissions } = this.props;
        const userHasViewCustomerPermission = userPermissions.includes('view customer');
        const userHasDeleteCustomerPermission = userPermissions.includes('delete customer');
        const columns = contactColumns({ canView: userHasViewCustomerPermission, canDelete: userHasDeleteCustomerPermission, onView: row => this.handleCustomerDetail(row.id), onDelete: row => this.handleDelete(row.id) });

        return (
            <DataTable
                ref={this.tableRef}
                dataEndpoint={"business/customer/all"}
                columns={columns}
                onRowClicked={userHasViewCustomerPermission ? row => this.handleCustomerDetail(row.id) : undefined}
                progressPending={pending}>
            </DataTable>
        )
    }

}
export default withPermissions(withRouter(CustomersTable));
